import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import CellRendererLink from "@/components/visit-point/list/cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "@/components/visit-point/list/cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "@/components/visit-point/list/cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "@/components/visit-point/list/cell-renderer/CellRendererActions.vue";
import CellRendererType from "@/components/visit-point/list/cell-renderer/CellRendererType.vue";
import CellRendererAdditionalFields from "@/components/visit-point/list/cell-renderer/CellRendererAdditionalFields.vue";
import CellRendererDemandText from "@/components/visit-point/list/cell-renderer/demand/CellRendererDemandText.vue";
import CellRendererDemand from "@/components/visit-point/list/cell-renderer/demand/CellRendererDemand.vue";
import CellRendererTypeServiceText from "@/components/visit-point/list/cell-renderer/CellRendererTypeServiceText.vue";

window.numberParser = function numberParser(params) {
	return Number(params.newValue) | 0;
};

export const visitPoinListMixin = {
	name: "VisitPoinList",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: false,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					cellRendererAdditionalFields: false,
					CellRendererDemand: false,
					CellRendererTypeService: false,
					showPopup: false,
					showActions: false,
				};
			},
		},
		relatedIds: {
			type: Array,
			default: () => [],
		},
		status_id: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererLink,
		CellRendererStatus,
		CellRendererVerified,
		CellRendererActions,
		CellRendererType,
		CellRendererAdditionalFields,
		CellRendererDemand,
		CellRendererDemandText,
		CellRendererTypeServiceText,
	},
	data() {
		return {
			roleFilter: {label: "All", value: "all"},
			statusFilter: {label: "All", value: "all"},
			isVerifiedFilter: {label: "All", value: "all"},
			departmentFilter: {label: "All", value: "all"},
			searchQuery: [],
			currentPageLocal: 1,
			quantityElementPage: 10,
			searchField: "Identification",
			gridApi: null,
			gridOptions: {},
			isExactly: false,
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			components: {
				CellRendererLink,
				CellRendererStatus,
				CellRendererVerified,
				CellRendererActions,
				CellRendererType,
				CellRendererAdditionalFields,
				CellRendererDemand,
				CellRendererDemandText,
				CellRendererTypeServiceText,
			},
		};
	},
	watch: {
		roleFilter(obj) {
			this.setColumnFilter("typology_name", obj.value);
		},
		statusFilter(obj) {
			this.setColumnFilter("status_name", obj.value);
		},
		isVerifiedFilter(obj) {
			let val = "";
			if (obj.value === "all") {
				val = "all";
			} else if (obj.value === "yes") {
				val = "true";
			} else {
				val = "false";
			}
			this.setColumnFilter("is_verified", val);
		},
		departmentFilter(obj) {
			this.setColumnFilter("department", obj.value);
		},
		currentPageLocal(page) {
			this.getVisitPoint(page);
		},
		quantityElementPage() {
			this.getVisitPoint(1);
		},
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		columnDefs() {
			let filterHead = this.customConfig.filterHead !== undefined ? this.customConfig.filterHead : true;
			let columns = [
				{
					headerName: "ID",
					field: "id",
					width: 150,
					filter: filterHead,
					checkboxSelection: this.customConfig.activeCheckbox,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: this.customConfig.activeHeaderCheckboxSelection,
					cellRendererFramework: this.customConfig.activeLink ? "CellRendererLink" : null,
					pinned: this.customConfig.activeCheckbox ? "left" : "",
				},
				{
					headerName: this.$t("Routing.Table.Identification"),
					field: "identification",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("Routing.Table.Latitude"),
					field: "cy",
					filter: filterHead,
					width: 170,
				},
				{
					headerName: this.$t("Routing.Table.Longitude"),
					field: "cx",
					filter: filterHead,
					width: 170,
				},
				{
					headerName: this.$t("Address"),
					field: "address",
					filter: filterHead,
					width: 250,
				},
				{
					headerName: this.$t("Divipola.Department"),
					field: "department",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("Divipola.City"),
					field: "city",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("Routing.CreateVisitPoint.ServiceTime"),
					field: "time_service",
					filter: filterHead,
					width: 180,
				},
				{
					headerName: this.$t("Priority"),
					field: "priority",
					filter: filterHead,
					width: 150,
				},
				{
					headerName: this.$t("TypeConfig.Form.Status"),
					field: "status_name",
					filter: filterHead,
					width: 150,
					cellRendererFramework: "CellRendererStatus",
				},
				{
					headerName: this.$t("ResourceModule.Table.Actions"),
					field: "transactions",
					width: 120,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			if (this.customConfig.cellRendererAdditionalFields) {
				columns.push({
					headerName: this.$t("AdditionalFields"),
					field: "additional_info",
					width: 350,
					filter: filterHead,
					cellRendererFramework: "CellRendererAdditionalFields",
				});
			}
			if (this.customConfig.CellRendererDemand) {
				columns.splice(2, 0, {
					headerName: this.$t("Routing.Table.Demand"),
					field: "demand",
					filter: filterHead,
					editable: true,
					width: 130,
					valueParser: numberParser,
					cellRendererFramework: "CellRendererDemandText",
				});
			}
			if (this.customConfig.CellRendererTypeService) {
				columns.splice(3, 0, {
					headerName: this.$t("TypeOfService"),
					field: "typeService",
					filter: filterHead,
					editable: true,
					width: 170,
					cellRendererFramework: "CellRendererTypeServiceText",
					cellEditor: "agSelectCellEditor",
					cellEditorParams: {values: [this.$t("PICKUP"), this.$t("DELIVERY")]},
				});
			}
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}

			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`ResourceModule.Table.${this.searchField}`);
		},
		usersData() {
			return this.$store.state.moduleVisitPoint.visitPoints;
		},
		getCheckedVisitPoints() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoits;
		},
	},
	methods: {
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		getVisitPoint(page) {
			this.onBtShowLoading();
			const payload = {
				sort: "desc",
				page,
				quantity: this.quantityElementPage,
				status_id: this.status_id,
				match_filter: !this.isExactly,
				order_by: ["id"],
			};
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginated", payload)
				.then((res) => {
					const dataFilters = res.records
						.filter((record) => record.json_properties)
						.map((field) => field.json_properties);
					const additionalInfo = [];
					dataFilters.forEach((data) => {
						data.forEach((info) => additionalInfo.push(info));
					});
					this.$emit("renderComponentEmit", true);
					this.$emit("getAdditionalInfo", additionalInfo);
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		searchVisitPoint() {
			const searchQueryList = this.searchQuery.map(({value}) => value);
			const dataPage = {
				identification: this.searchField === "Identification" ? searchQueryList : [],
				address: this.searchField === "Address" ? searchQueryList : [],
				department: this.searchField === "Department" ? searchQueryList : [],
				city: this.searchField === "City" ? searchQueryList : [],
				status_id: this.status_id,
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginated", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		searchAssignedVisitPoint(searchField, searchQuery, page) {
			const searchQueryList = searchQuery.map(({value}) => value);
			const dataPage = {
				identification: searchField === "Identification" ? searchQueryList : [],
				address: searchField === "Address" ? searchQueryList : [],
				department: searchField === "Department" ? searchQueryList : [],
				city: searchField === "City" ? searchQueryList : [],
				additional_info: searchField === "AdditionalFields" ? searchQuery : [],
				page: page ? page : currentPageLocal,
				status_id: this.status_id,
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginated", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		crear() {
			this.$router.push(`/apps/resource/user-create`);
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		onGridReady() {},
		rowSelected(event) {
			const isSelected = event.node.isSelected();
			if (isSelected) {
				this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED", event.data);
			} else {
				this.$store.commit("moduleVisitPoint/REMOVE_VISIT_POINT_CHECKED", event.data);
			}
		},
		onSelectionChanged() {
			const selectedRows = this.getCheckedVisitPoints;
			if (this.customConfig.rowSelection === "single") {
				this.$store.dispatch("moduleVisitPoint/currentVisitPointSelected", selectedRows[0]);
			}
		},
		setDefaultSelectedRow() {
			const relatedIds = this.getCheckedVisitPoints;
			if (relatedIds.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIds.some((r) => r.id === node.data.id);
					node.setSelected(valid);
				});
			}
		},
		refreshVisitPoint() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED");
			this.getVisitPoint(1);
		},
		setSearchField(val) {
			this.searchField = val;
		},
		updateDemand(amount) {
			if (this.getCheckedVisitPoints.length > 0) {
				this.getCheckedVisitPoints.forEach((visitPoint) => {
					this.usersData.forEach((user) => {
						if (visitPoint.id === user.id) user.demand = amount;
					});
				});
				this.gridApi.setRowData(this.usersData);
				this.setDefaultSelectedRow();
			}
		},
		updateService(type) {
			if (this.getCheckedVisitPoints.length > 0) {
				this.getCheckedVisitPoints.forEach((visitPoint) => {
					this.usersData.forEach((user) => {
						if (visitPoint.id === user.id) user.typeService = type;
					});
				});
				this.gridApi.setRowData(this.usersData);
				this.setDefaultSelectedRow();
			}
		},
		openEnableConfirm(val) {
			if (val) {
				this.$vs.dialog({
					type: "confirm",
					color: "primary",
					title: this.$t("Confirm"),
					text: `${this.$t("Preferences.FilterSearchExactText")}`,
					accept: () => {
						this.isExactly = val;
						this.updateMatchFilter();
					},
					cancel: () => {
						this.isExactly = false;
					},
					acceptText: this.$t("Accept"),
					cancelText: this.$t("Cancel"),
				});
			} else {
				this.isExactly = val;
				this.updateMatchFilter();
			}
		},
		async updateMatchFilter() {
			const payload = {};
			payload["filter_exact_visit_point"] = this.isExactly;
			try {
				await this.$store.dispatch("moduleMatchFilter/updateMatchFilter", payload);
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
	},
	async mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		const matchFilter = await this.$store.dispatch("moduleMatchFilter/getMatchFilter");
		if (Object.entries(matchFilter) > 0) {
			this.isExactly = matchFilter.filter_exact_visit_point;
		} else {
			this.isExactly = this.$store.state.moduleMatchFilter.filter_exact_visit_point;
		}
		this.$emit("gridApiEmit", this.gridApi);
		this.getVisitPoint(1);
	},
	beforeDestroy() {
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED");
	},
};
